import React from 'react';
import { ReactSVG } from 'react-svg';

import { TextField } from '../TextField';
import { isMobileValidHr } from './mobilePhoneUtilsHr';
import { formatMobileHr } from './mobilePhoneUtilsHr';
import { classNames } from 'helpers';

const MobilePhoneTextField = ({
  value,
  onChange,
  error,
  disabled,
  cssClassName,
  placeholder="npr. 091 234 5678",
  ...props
}: any) => {
  const phone = typeof value === 'string' ? value : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatMobileHr(e.target.value);

    onChange?.({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: formatted,
      },
    });
  };

  const isValid = !phone || isMobileValidHr(phone);
  const showIcons = disabled && phone && isValid;

  // If phone is valid, don't show external error (it will clear on next form validation)
  const displayError = (phone && isValid) ? undefined : (!isValid ? 'Neispravan broj mobitela' : error);

  // Remove all non-digit characters for WhatsApp and Viber
  const cleanPhone = phone.replace(/\D/g, '');

  const handleWhatsAppClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (cleanPhone && isValid) {
      // WhatsApp uses international format without +
      const internationalPhone = cleanPhone.startsWith('0')
        ? '385' + cleanPhone.substring(1)
        : cleanPhone;
      window.open(`https://wa.me/${internationalPhone}`, '_blank', 'noopener,noreferrer');
    }
  };

  const handleViberClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (cleanPhone && isValid) {
      // Viber uses international format with +
      const internationalPhone = cleanPhone.startsWith('0')
        ? '+385' + cleanPhone.substring(1)
        : '+' + cleanPhone;
      window.open(`viber://chat?number=${encodeURIComponent(internationalPhone)}`, '_blank');
    }
  };


  return (
    <div className="relative">
      <TextField
        {...props}
        value={phone}
        onChange={handleChange}
        error={displayError}
        placeholder={placeholder}
        inputMode="tel"
        disabled={disabled}
        disableDebounce
        cssClassName={classNames(cssClassName, showIcons ? "pr-20" : "")}
      />
      {showIcons && (
        <div className="absolute right-2 top-[54px] -translate-y-1/2 z-20 flex ">
          <button
            type="button"
            onClick={handleWhatsAppClick}
            className="p-1 rounded hover:bg-green-600 transition-colors duration-200 group"
            title={`Pošalji WhatsApp poruku na ${phone}`}
          >
            <ReactSVG
              src="/media/icons/whatsapp.svg"
              className="w-5 h-5 text-green-500 group-hover:text-white transition-colors duration-200"
            />
          </button>
          <button
            type="button"
            onClick={handleViberClick}
            className="p-1 rounded hover:bg-purple-600 transition-colors duration-200 group"
            title={`Pošalji Viber poruku na ${phone}`}
          >
            <ReactSVG
              src="/media/icons/viber.svg"
              className="w-5 h-5 text-purple-500 group-hover:text-white transition-colors duration-200"
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default React.memo(MobilePhoneTextField);
